<p-panelMenu [model]="items" [multiple]="true">